export const POSTHOG_EVENTS = {
  COLLECTION_CARDS_ADDED: "collection_cards_added",
  DECK_CREATED: "deck_created",
  DECK_VISIBILITY_CHANGED: "deck_visibility_changed",
  DECK_WANT_LIST_CREATED: "deck_want_list_created",
  DECK_COPIED: "deck_copied",
  TRADE_LIST_CREATED: "trade_list_created",
  TRADE_LIST_DELETED: "trade_list_deleted",
  TRADE_MATCHES_LOADED: "trade_matches_loaded",
  TRADE_MATCH_VIEWED: "trade_match_viewed",
  TRADE_MATCH_ACTIONED: "trade_match_actioned",
  TRADE_MESSAGE_SENT: "trade_message_sent",
  TRADE_PROPOSAL_CREATED: "trade_proposal_created",
  TRADE_PROPOSAL_ACCEPTED: "trade_proposal_accepted",
  TRADE_PROPOSAL_COMPLETED: "trade_proposal_completed",
  TRADE_PROPOSAL_DECLINED: "trade_proposal_declined",
  USER_STORES_UPDATED: "user_stores_updated",
  ONBOARDING_STARTED: "onboarding_started",
  ONBOARDING_STEP_VIEWED: "onboarding_step_viewed",
  ONBOARDING_STEP_COMPLETED: "onboarding_step_completed",
  ONBOARDING_STEP_SKIPPED: "onboarding_step_skipped",
  ONBOARDING_STEP_FAILED: "onboarding_step_failed",
  ONBOARDING_EXIT_SELECTED: "onboarding_exit_selected",
  ONBOARDING_COMPLETED: "onboarding_completed",
  ACQUISITION_LANDING_VIEWED: "acquisition_landing_viewed",
  ACQUISITION_CODE_CAPTURED: "acquisition_code_captured",
  ACQUISITION_OPEN_APP_CLICKED: "acquisition_open_app_clicked",
  ACQUISITION_CODE_COPIED: "acquisition_code_copied",
  ACQUISITION_CLAIMED: "acquisition_claimed",
  REFERRAL_LANDING_VIEWED: "referral_landing_viewed",
  REFERRAL_OPEN_APP_CLICKED: "referral_open_app_clicked",
  REFERRAL_CODE_COPIED: "referral_code_copied",
  REFERRAL_CLAIMED: "referral_claimed",
  VISITOR_CTA_VIEWED: "visitor_cta_viewed",
  VISITOR_CTA_CLICKED: "visitor_cta_clicked",
} as const;

export type PostHogEvent = (typeof POSTHOG_EVENTS)[keyof typeof POSTHOG_EVENTS];

export type AnalyticsProperties = Record<
  string,
  boolean | number | string | undefined
>;
